export default function decodeOAuthState(stateValue = '') {
    const normalized = (stateValue || '').toString().trim();

    if (!normalized) {
        return '';
    }

    if (normalized.startsWith('{') || normalized.startsWith('[')) {
        return normalized;
    }

    if (normalized.length % 2 === 0 && /^[0-9a-fA-F]+$/.test(normalized)) {
        let raw = '';

        for (let i = 0; i < normalized.length; i += 2) {
            const byte = parseInt(normalized.substr(i, 2), 16);
            if (Number.isNaN(byte)) {
                return normalized;
            }
            raw += String.fromCharCode(byte);
        }

        try {
            return decodeURIComponent(escape(raw)); // decode UTF-8 bytes represented as hex
        } catch (e) {
            return raw;
        }
    }

    return normalized;
}
